import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson1DefaultStartCode = `%lang starknet
${doNotModifyCodeAbove}`;

export const lesson1DefaultMiddleCode = `// Starknet provides a module management system.
// It is very similar to the Python's one.
// TODO: add the module imports needed to make the test pass!
// Help: for help check out this link to find the relevant import statement
// https://www.cairo-lang.org/docs/how_cairo_works/builtins.html#builtins`;

export const lesson1DefaultEndCode = `${doNotModifyCodeBelow}
@external
func test_ok{syscall_ptr : felt*, pedersen_ptr : HashBuiltin*, range_check_ptr}() {
    return ();
}`;
